/* eslint-disable @nx/enforce-module-boundaries */
import { Component, Input } from '@angular/core';

import { NavigationItem } from '@cigna/chcp/shared/util';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';

@Component({
  selector: 'cigna-nav-links',
  templateUrl: './nav-links.component.html',
  styleUrls: ['./nav-links.component.scss'],
})
export class NavLinksComponent {
  @Input() links: NavigationItem[] = [];
  @Input() isImpersonator = false;

  isEnhancedBrighterFederation$ = this.featureTogglesFacade.featuresEnabled([
    'ftr-chcp-global-team-web-auth0',
  ]);

  constructor(public featureTogglesFacade: FeatureTogglesFacade) {}
}
